import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/sellers/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/sellers`, config),
    fetchAll: (config: AxiosRequestConfig) => api.get(`/sellers/all`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/sellers/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/sellers`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/sellers/${url.id}`, data, config),
};

export default requests;
